import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// import HoverIntent from 'react-hoverintent';
import { ArrowDownIcon, EmptyShoppingBag } from '../../../../UI/Icons/Icons';
import { savePersonalizationPointsToDatabase } from '../../../../../util/personalization';

export class MyDillardsBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMyDillardsLogo: false,
      showAccountDD: false,
      loaded: false,
    };
    this.state.mouseover = false;
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.showAccountDD = this.showAccountDD.bind(this);
    this.hideAccountDD = this.hideAccountDD.bind(this);
    this.toggleAccountDD = this.toggleAccountDD.bind(this);
    this.handleShowDillardsLogo = this.handleShowDillardsLogo.bind(this);
  }

  onMouseOver() {
    if (window.DILLARDS.country == 'US') this.setState({ mouseover: true });
  }

  onMouseOut() {
    this.setState({ mouseover: false });
  }

  preventDoubleClick() {
    if (document.getElementsByClassName('shopping-bag-count-container')[0]) {
      document.getElementsByClassName('shopping-bag-count-container')[0].style.pointerEvents = 'none';
    }
  }

  toggleAccountDD() {
    this.setState({ showAccountDD: !this.state.showAccountDD });
  }

  showAccountDD() {
    this.setState({ showAccountDD: true });
  }

  hideAccountDD() {
    this.setState({ showAccountDD: false });
  }

  handleShowDillardsLogo() {
    if (this.props.passedAppFunctions.siteFormat === 'desktop') {
      const initialPosition = window.scrollY || document.documentElement.scrollTop;

      const dillardsBarWrapper = document.querySelector('#my_dillards_bar_wrapper');
      if (!dillardsBarWrapper) return;

      if (dillardsBarWrapper.getBoundingClientRect().top <= 1 && initialPosition > 0) {
        if (!this.state.showMyDillardsLogo) {
          document.getElementById('backgroundContainer').classList.add('dropShadow');
          this.setState({ showMyDillardsLogo: true });
        }
      } else {
        if (this.state.showMyDillardsLogo) {
          document.getElementById('backgroundContainer').classList.remove('dropShadow');
          this.setState({ showMyDillardsLogo: false });
        }
      }
    }
  }

  handleLoadState() {
    this.setState({ loaded: true });
  }

  componentDidMount() {
    this.handleLoadState();
    if (this.props.passedAppFunctions.siteFormat == 'desktop') {
      this.handleShowDillardsLogo();
    }
    window.addEventListener('scroll', this.handleShowDillardsLogo);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleShowDillardsLogo);
  }

  render() {
    let { mouseover } = this.state.mouseover;

    return this.state.loaded ? (
      <div id='myDillardsBarContainer'>
        <div
          id='my_dillards_bar_wrapper'
          tabIndex='-1'
          className={`dillardsBarPromo ${this.state.showMyDillardsLogo ? 'backgroundBlack' : ''}`}
          onTouchEnd={this.props.closeMenu}
        >
          <div className={`${this.props.passedAppFunctions.siteFormat == 'tablet' ? 'container' : 'container-fluid'}`}>
            <div className='mdbContainer__row row'>
              <div className='col-sm-12'>
                <ul className='barItems'>
                  <li className='logoListitem'>
                    {this.props.passedAppFunctions.siteFormat == 'desktop' ? (
                      <Link to='/' rel='nofollow' className='logo-spot'>
                        <img
                          className='myDillardsLogo'
                          src='/assets/img/logos/smallDillardsLogo.png'
                          width='59'
                          height='15'
                          alt="Dillard's Logo"
                        ></img>
                      </Link>
                    ) : (
                      ''
                    )}
                  </li>
                  {!this.state.showMyDillardsLogo && (
                    <>
                      <li className='barItems__li'>
                        <Link to='/c/back-in-stock' manual_cm_sp='Header-_-BackInStock-_-TextLink'>
                          Back In Stock
                        </Link>
                      </li>
                      <li className='barItems__li'>
                        <Link
                          to='/c/sale-clearance'
                          manual_cm_sp='Header-_-SaleClearance-_-TextLink'
                          className='sale-clearance text--clearance'
                        >
                          Sale and Clearance
                        </Link>
                      </li>
                      <li className='barItems__li'>
                        <Link to='/c/shopbybrand' manual_cm_sp='Header-_-ShopByBrand-_-TextLink'>
                          Shop By Brand
                        </Link>
                      </li>
                      <li className='barItems__li'>
                        <Link
                          to='/c/limited-availability'
                          manual_cm_sp='Header-_-LimitedAvailability-_-TextLink'
                          className='text--limitedAvailability'
                        >
                          Limited Availability
                        </Link>
                      </li>
                      <li className='barItems__li hide-when-international'>
                        <Link
                          to='/c/DillardsCard?cmp=A~H~A~Z~8~E~ZZZ1~CC~DL~LC'
                          manual_cm_sp='Header-_-CreditCard-_-TextLink'
                          className='text--creditCard citi-link'
                        >
                          Credit Card
                        </Link>
                      </li>
                    </>
                  )}
                  <li
                    className='barItems__li hide-when-international myAccountDD'
                    onMouseOver={this.showAccountDD}
                    onMouseOut={this.hideAccountDD}
                  >
                    {this.props.myDillardsInfo.userInformation.userLoggedInStatus === 'guest' ||
                    this.props.myDillardsInfo.userInformation.userLoggedInStatus === 'registered' ? (
                      <Link
                        to='/webapp/wcs/stores/servlet/LogonForm?storeId=301&langId=-1&catalogId=301'
                        rel='nofollow'
                        aria-label='login'
                        aria-describedby='login menu'
                      >
                        {this.props.myDillardsInfo.userInformation.userLoggedInStatus === 'guest'
                          ? 'Login'
                          : 'My Account'}
                      </Link>
                    ) : (
                      ''
                    )}
                    {this.props.myDillardsInfo.userInformation.persistent === 'persistent' ||
                    this.props.myDillardsInfo.userInformation.userLoggedInStatus === 'persistent' ? (
                      <Link
                        to={`/webapp/wcs/stores/servlet/RememberMeLogonFormView?URL=${location.pathname}`}
                        rel='nofollow'
                        aria-label='login'
                        aria-describedby='login menu'
                      >
                        Login
                      </Link>
                    ) : (
                      ''
                    )}
                    <button
                      onClick={this.toggleAccountDD}
                      className='btn-tertiary'
                      type='button'
                      aria-label='Login'
                      aria-controls='accountDDContainer'
                      aria-expanded={this.state.showAccountDD ? 'true' : 'false'}
                    >
                      <ArrowDownIcon downArrowTitleId='loginMenu' downArrowTitleDesc='Login Menu Dropdown' />
                    </button>
                    <div
                      id='accountDDContainer'
                      className={`accountDDContainer ${this.state.showAccountDD ? 'accountDDShowContainer' : ''}`}
                    >
                      <div className='accountDD'>
                        <ul>
                          {this.props.myDillardsInfo.userInformation.userLoggedInStatus === 'guest' ? (
                            <li className='hide-when-international login'>
                              <Link
                                to='/webapp/wcs/stores/servlet/LogonForm?storeId=301&langId=-1&catalogId=301'
                                rel='nofollow'
                              >
                                Login
                              </Link>
                            </li>
                          ) : (
                            ''
                          )}
                          {this.props.myDillardsInfo.userInformation.persistent !== undefined &&
                          this.props.myDillardsInfo.userInformation.persistent === 'persistent' ? (
                            <li className='hide-when-international login'>
                              <Link
                                to={`/webapp/wcs/stores/servlet/RememberMeLogonFormView?URL=${location.pathname}`}
                                rel='nofollow'
                              >
                                Login
                              </Link>
                            </li>
                          ) : (
                            ''
                          )}
                          {this.props.myDillardsInfo.userInformation.persistent === undefined ||
                          this.props.siteFormat == 'tablet' ? (
                            <li className='hide-when-international'>
                              <Link
                                to='/webapp/wcs/stores/servlet/LogonForm?storeId=301&langId=-1&catalogId=301'
                                rel='nofollow'
                              >
                                My Dillard&apos;s Account
                              </Link>
                            </li>
                          ) : (
                            <li className='hide-when-international'>
                              <a
                                href='/webapp/wcs/stores/servlet/LogonForm?storeId=301&langId=-1&catalogId=301'
                                rel='nofollow'
                              >
                                My Dillard&apos;s Account
                              </a>
                            </li>
                          )}
                          {this.props.myDillardsInfo.userInformation.persistent === undefined ||
                          this.props.siteFormat == 'tablet' ? (
                            <li className='hide-when-international'>
                              <Link to='/c/just-for-you' rel='nofollow'>
                                Just For You
                              </Link>
                            </li>
                          ) : (
                            <li className='hide-when-international'>
                              <a href='/c/just-for-you' rel='nofollow'>
                                Just For You
                              </a>
                            </li>
                          )}
                          {this.props.myDillardsInfo.userInformation.persistent === undefined ? (
                            <li className='hide-when-international'>
                              <Link
                                to='/webapp/wcs/stores/servlet/OrderStatusLoginChk?storeId=301&catalogId=301&langId=-1&orderStatus=true'
                                rel='nofollow'
                              >
                                Order History
                              </Link>
                            </li>
                          ) : (
                            <li className='hide-when-international'>
                              <Link
                                to='/webapp/wcs/stores/servlet/OrderStatusLoginChk?storeId=301&catalogId=301&langId=-1&orderStatus=true'
                                rel='nofollow'
                              >
                                Order History
                              </Link>
                            </li>
                          )}
                          {this.props.myDillardsInfo.userInformation.persistent === undefined ? (
                            <li className='hide-when-international'>
                              <Link to='/c/returns' rel='nofollow'>
                                Returns
                              </Link>
                            </li>
                          ) : (
                            <li className='hide-when-international'>
                              <Link to='/c/returns' rel='nofollow'>
                                Returns
                              </Link>
                            </li>
                          )}
                          {this.props.myDillardsInfo.userInformation.persistent === undefined ? (
                            <li className='hide-when-international payMyBillBtn'>
                              <button
                                className='btn-tertiary payMyBillBtn'
                                data-toggle='modal'
                                data-target='.citi-speedbump'
                                data-modal-title=' '
                                data-modal-body='citibankSpeedbump({"citiLink": "https://citiretailservices.citibankonline.com/RSauth/signon?pageName=signon&siteId=PLCN_DILLARDS&langId=en_US"})'
                              >
                                Pay My Bill
                              </button>
                            </li>
                          ) : (
                            <li className='hide-when-international payMyBillBtn'>
                              <button
                                className='btn-tertiary'
                                data-toggle='modal'
                                data-target='.citi-speedbump'
                                data-modal-title=' '
                                data-modal-body='citibankSpeedbump({"citiLink": "https://citiretailservices.citibankonline.com/RSauth/signon?pageName=signon&siteId=PLCN_DILLARDS&langId=en_US"})'
                              >
                                Pay My Bill
                              </button>
                            </li>
                          )}

                          {this.props.myDillardsInfo.userInformation.persistent === undefined ? (
                            <li className='hide-when-international'>
                              <Link
                                to='/webapp/wcs/stores/servlet/LogonForm?storeId=301&catalogId=301&langId=-1&rURL=InterestItemDisplay'
                                rel='nofollow'
                              >
                                My Wish List
                              </Link>
                            </li>
                          ) : (
                            <li className='hide-when-international'>
                              <Link
                                to='/webapp/wcs/stores/servlet/InterestItemDisplay?storeId=301&catalogId=301&langId=-1'
                                rel='nofollow'
                              >
                                My Wish List
                              </Link>
                            </li>
                          )}
                          {this.props.myDillardsInfo.userInformation.persistent === undefined ? (
                            <li className='hide-when-international'>
                              <Link to='/stores' rel='nofollow'>
                                Store Locator
                              </Link>
                            </li>
                          ) : (
                            <li className='hide-when-international'>
                              <Link to='/stores' rel='nofollow'>
                                Store Locator
                              </Link>
                            </li>
                          )}
                          {this.props.myDillardsInfo.userInformation.persistent !== undefined &&
                          this.props.myDillardsInfo.userInformation.DefaultRegistry ? (
                            <li className='hide-when-international'>
                              <Link
                                to={`/webapp/wcs/stores/servlet/RegistryManageProducts?catalogId=301&langId=-1&storeId=301&actionCode=M&registryNumber=${this.props.myDillardsInfo.userInformation.DefaultRegistry}`}
                                rel='nofollow'
                              >
                                My Registry
                              </Link>
                            </li>
                          ) : (
                            ''
                          )}
                          {this.props.myDillardsInfo.userInformation.userLoggedInStatus === 'registered' ? (
                            <li className='hide-when-international logout'>
                              <Link
                                to={`/webapp/wcs/stores/servlet/Logoff?URL=/`}
                                rel='nofollow'
                                onClick={() =>
                                  savePersonalizationPointsToDatabase(this.props.passedAppFunctions.wasParms, false)
                                }
                              >
                                Logout
                              </Link>
                            </li>
                          ) : (
                            ''
                          )}
                        </ul>
                      </div>
                    </div>
                  </li>

                  {
                    <li className='barItems__li barItems__li--noborders shopping-bag-count-container'>
                      <Link
                        onClick={this.preventDoubleClick}
                        style={this.state.disableClick ? { pointerEvents: 'none' } : {}}
                        className='d-inline-block shoppingBagLink'
                        to='/webapp/wcs/stores/servlet/OrderItemDisplay?storeId=301&catalogId=301&langId=-1'
                        rel='nofollow'
                      >
                        <EmptyShoppingBag />
                        <span className='cartItemCount'>{this.props.myDillardsInfo.miniCartInfo.cartItemCount}</span>
                        <span className='sr-only'> items in cart</span>
                      </Link>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div id='myDillardsBarContainer'>
        <div
          id='my_dillards_bar_wrapper'
          tabIndex='-1'
          className='dillardsBarPromo'
          onTouchEnd={this.props.closeMenu}
        ></div>
      </div>
    );
  }
}

MyDillardsBar.propTypes = {
  handleMyDillardsBoxClick: PropTypes.func,
};

export default MyDillardsBar;
